import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {IFilterQueryLr} from '../core/_models'
import {enableMapSet} from 'immer'

enableMapSet()
export interface LrFilterState {
  query: IFilterQueryLr
}

const initialState: IFilterQueryLr = {}

const lrFilterSlice = createSlice({
  name: 'lrFilter',
  initialState: initialState,
  reducers: {
    updateQuery(state, action: PayloadAction<Partial<IFilterQueryLr>>) {
      Object.assign(state, action.payload)
    },
    setQuery(state, action: PayloadAction<IFilterQueryLr>) {
      return action.payload
    },

    resetQuery(state) {
      delete state.rules
    },
  },
})

export const {resetQuery, setQuery, updateQuery} = lrFilterSlice.actions
export default lrFilterSlice.reducer
